module.exports = __webpack_public_path__ + "img/icon-repeat-customers.6f93bbb.svg";